<div class="title">
  <span>{{ title }}
    <app-basic-button type="secondary" isIcon="true" size="medium" (click)="openHelp()">
      <i class="fal far fa-info-circle fs-16"></i>
    </app-basic-button>
  </span>
  <i class="close-icon" (click)="cancel()"></i>
</div>

<div class="dialog-body">
  <!-- File picker -->
  <div class="form-row">
    <label class="field-label">Select a .csv/.txt file</label>
    <div class="file-input-wrapper">
      <input type="file" #fileInput accept=".csv,.txt" (change)="onFileSelected($event)" hidden />
      <div class="file-drop-zone"
           [class.drag-over]="isDragOver"
           (click)="fileInput.click()"
           (dragover)="onDragOver($event)"
           (dragleave)="onDragLeave($event)"
           (drop)="onDrop($event)">
        <i class="far fa-cloud-upload fs-20"></i>
        <span *ngIf="!fileName">Drag & drop or click to select a file</span>
        <span *ngIf="fileName" class="file-name">{{ fileName }}</span>
      </div>
    </div>
  </div>

  <!-- Options row -->
  <div class="form-row options-row">
    <div class="option-field">
      <app-basic-dropdown
        [showIcon]="false"
        [appendTo]="'#ddl-panel-wrapper'"
        [label]="'Delimiter'"
        [items]="delimiterOptions"
        bindLabel="label"
        bindValue="value"
        [(model)]="selectedDelimiter"
        [width]="'180px'"
        [clearable]="false"
        [searchable]="false"
        (modelChange)="onDelimiterChange()">
      </app-basic-dropdown>
    </div>
    <div class="option-field">
      <app-basic-dropdown
        [showIcon]="false"
        [appendTo]="'#ddl-panel-wrapper'"
        [label]="'Encoding'"
        [items]="encodingOptions"
        bindLabel="label"
        bindValue="value"
        [(model)]="selectedEncoding"
        [width]="'180px'"
        [clearable]="false"
        [searchable]="false"
        (modelChange)="onEncodingChange()">
      </app-basic-dropdown>
    </div>
  </div>

  <!-- Expected columns info -->
  <div class="columns-info" *ngIf="data.columns?.length">
    <label class="field-label">Expected columns</label>
    <div class="column-chips">
      <span *ngFor="let col of data.columns" class="column-chip" [class.required]="col.required">
        {{ col.name }}
        <span *ngIf="col.required" class="req-badge">*</span>
      </span>
    </div>
  </div>

  <!-- Missing required warning -->
  <div class="warning-banner" *ngIf="missingRequiredColumns.length">
    <i class="far fa-exclamation-triangle"></i>
    <span>Missing required columns: {{ missingRequiredColumns.join(', ') }}</span>
  </div>

  <!-- Validation warning -->
  <div class="warning-banner" *ngIf="hasInvalidChars">
    <i class="far fa-exclamation-triangle"></i>
    <span>{{ validationMessages.join('. ') }}</span>
  </div>

  <!-- Server validation errors -->
  <div class="warning-banner server-error-banner" *ngIf="hasServerErrors">
    <i class="far fa-exclamation-triangle"></i>
    <span>{{ serverValidationMessages.join('. ') }}</span>
  </div>

  <!-- Validating spinner -->
  <div class="validating-banner" *ngIf="isValidating">
    <i class="far fa-spinner fa-spin"></i>
    <span>Validating with server...</span>
  </div>

  <!-- Parse error -->
  <div class="error-banner" *ngIf="parseError">
    <i class="far fa-exclamation-circle"></i>
    <span>{{ parseError }}</span>
  </div>

  <!-- Preview table -->
  <div class="table-container" *ngIf="parsedHeaders.length">
    <label class="field-label">Preview ({{ parsedRows.length }} rows)</label>
    <div class="table-scroll">
      <table class="preview-table">
        <thead>
          <tr>
            <th *ngFor="let header of parsedHeaders"
                [class.extra-column]="isExtraColumn(header)">
              {{ header }}
              <i *ngIf="isExtraColumn(header)" class="far fa-exclamation-circle extra-icon"
                 matTooltip="This column is not in the expected list"
                 matTooltipClass="tooltip-font-14"></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of parsedRows; let ri = index">
            <td *ngFor="let cell of row; let ci = index"
                [class.extra-column]="parsedHeaders[ci] && isExtraColumn(parsedHeaders[ci])"
                [class.invalid-cell]="isCellInvalid(ri, ci)"
                [class.server-error-cell]="isCellServerError(ri, ci)"
                [matTooltip]="getCellTooltip(ri, ci, cell)"
                [matTooltipDisabled]="!isCellInvalid(ri, ci) && !isCellServerError(ri, ci)"
                matTooltipClass="tooltip-font-14">
              {{ cell }}
              <i *ngIf="isCellInvalid(ri, ci)" class="far fa-exclamation-circle invalid-icon"></i>
              <i *ngIf="isCellServerError(ri, ci) && !isCellInvalid(ri, ci)" class="far fa-exclamation-circle server-error-icon"></i>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<div class="dialog-actions">
  <app-basic-button type="secondary" size="medium" (click)="cancel()">
    Cancel
  </app-basic-button>
  <app-basic-button type="primary" size="medium" (click)="confirm()"
    [disabled]="!parsedHeaders.length || missingRequiredColumns.length > 0 || hasInvalidChars || hasServerErrors || isValidating || totalRowCount > maxRows">
    Import
  </app-basic-button>
</div>
